export default "__VITE_ASSET__DXwpvFvk__"